

export enum StepStatus {
  PENDING  = 'pending',
  ACTIVE   = 'active',
  COMPLETE = 'complete',
}

export enum CampaignSetupParticipationMethod {
  STRIPE_PAYMENT = 134,
  STANDARD_FORM  = 135,
  CUSTOM_FORM    = 136,
}

export enum CampaignSetupItemListingType {
  SINGLE   = 47,
  MULTIPLE = 46,
  CUSTOM   = 141,
}
